<template>
  <div class="fav-record-main">
    <div class="main-box">
      <div class="depot-list-box">
        <div class="left-filter">
          <div class="ft-box" v-if="subjectDict && subjectDict.length > 0">
            <div class="tit">
              <i></i>主题分类
              <span
                :class="showAll[0] ? 'cur' : ''"
                @click="showAllHandle(0)"
              ></span>
            </div>
            <div :class="showAll[0] ? 'ft-lt cur' : 'ft-lt'">
              <div
                :class="-1 === subjectCurrent ? 'cur' : ''"
                @click="handleFilter(-1, -1, 'subject')"
              >
                <span>全部</span>
                <!-- <span>{{ subjectCount }}</span> -->
              </div>
              <div
                v-for="(item, index) in subjectDict"
                :key="'subjectDict' + index"
              :class="getFacetText('subjectDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                @click="handleFilter(item, index, 'subject')"
              >
                <span>{{ item.facet }}</span>
                <span>{{ item.count }}</span>
              </div>
            </div>
          </div>
          <div class="ft-box" v-if="plDict && plDict.length > 0">
            <div class="tit">
              <i></i>出版地点
              <span
                :class="showAll[1] ? 'cur' : ''"
                @click="showAllHandle(1)"
              ></span>
            </div>
            <div :class="showAll[1] ? 'ft-lt cur' : 'ft-lt'">
              <div
                :class="-1 === plCurrent ? 'cur' : ''"
                @click="handleFilter(-1, -1, 'pl')"
              >
                <span>全部</span>
                <!-- <span>{{ plCount }}</span> -->
              </div>
              <div
                v-for="(item, index) in plDict"
                :key="'plDict' + index"
               :class="getFacetText('plDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                @click="handleFilter(item, index, 'pl')"
              >
                <span>{{ item.facet }}</span>
                <span>{{ item.count }}</span>
              </div>
            </div>
          </div>
          <div class="ft-box" v-if="langDict && langDict.length > 0">
            <div class="tit">
              <i></i>语种
              <span
                :class="showAll[2] ? 'cur' : ''"
                @click="showAllHandle(2)"
              ></span>
            </div>
            <div :class="showAll[2] ? 'ft-lt cur' : 'ft-lt'">
              <div
                :class="-1 === langCurrent ? 'cur' : ''"
                @click="handleFilter(-1, -1, 'lang')"
              >
                <span>全部</span>
                <!-- <span>{{ langCount }}</span> -->
                  <!-- :class="item.facet === langCurrent ? 'cur' : ''" -->
              </div>
              <div
                v-for="(item, index) in langDict"
                :key="'langDict' + index"
                 :class="getFacetText('langDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                @click="handleFilter(item, index, 'lang')"
              >
                <span>{{ item.facet }}</span>
                <span>{{ item.count }}</span>
              </div>
            </div>
          </div>
        </div>
        <Player ref="player" @curPlay="curPlay" />
        <div
          :class="
            showMobileFilter ? 'mobile-filter-tk cur' : 'mobile-filter-tk'
          "
        >
          <div
            class="depot-filter"
            v-if="subjectDict && subjectDict.length > 0"
          >
            <span class="lb">主题分类</span>
            <div class="scroll-box">
              <div class="fs" :style="'width:' + subjectDict.length + 'rem'">
                 <!-- <div class="fs" style="max-height:.56rem;line-height:.3rem"> -->
                <span
                  :class="subjectCurrent === -1 ? 'cur' : ''"
                  @click="handleFilter(-1, -1, 'subject')"
                  >全部</span
                >
                <span
                  v-for="(item, index) in subjectDict"
                  :key="'subjectDict' + index"
                      :class="getFacetText('subjectDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                  @click="handleFilter(item, index, 'subject')"
                >
                  {{ item.facet }} <i>{{ item.count }}</i>
                </span>
              </div>
            </div>
          </div>
          <div class="depot-filter" v-if="plDict && plDict.length > 0">
            <span class="lb">出版地点</span>
            <div class="scroll-box">
              <div class="fs" :style="'width:' + plDict.length + 'rem'">
                 <!-- <div class="fs" style="max-height:.56rem;line-height:.3rem"> -->
                <span
                  :class="plCurrent === -1 ? 'cur' : ''"
                  @click="handleFilter(-1, -1, 'pl')"
                  >全部</span
                >
                <span
                  v-for="(item, index) in plDict"
                  :key="'plDict' + index"
                   :class="getFacetText('plDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                  @click="handleFilter(item, index, 'pl')"
                >
                  {{ item.facet }} <i>{{ item.count }}</i>
                </span>
              </div>
            </div>
          </div>
          <div class="depot-filter" v-if="langDict && langDict.length > 0">
            <span class="lb">语种</span>
            <div class="scroll-box">
              <div class="fs" :style="'width:' + langDict.length + 'rem'">
                 <!-- <div class="fs" style="max-height:.56rem;line-height:.3rem"> -->
                <span
                  :class="langCurrent === -1 ? 'cur' : ''"
                  @click="handleFilter(-1, -1, 'lang')"
                  >全部</span
                >
                <span
                  v-for="(item, index) in langDict"
                   :key="'langDict' + index"
                 :class="getFacetText('langDict').indexOf(item.facet)>=0 ? 'cur' : ''"
                  @click="handleFilter(item, index, 'lang')"
                >
                  {{ item.facet }} <i>{{ item.count }}</i>
                </span>
              </div>
            </div>
          </div>

          <div class="depot-slide">
            <div class="slide-box">
              <span class="lb">出版时间</span>
              <div class="slide">
                <a-slider
                  range
                  :min="1910"
                  :max="2015"
                  :default-value="[1910, 2015]"
                  @afterChange="onSliderChange"
                />
              </div>
              <div style="margin-left: 2%; color: #999">
                {{ sliderCurrVal[0] }}~{{ sliderCurrVal[1] }}
              </div>
            </div>
          </div>
          <div class="depot-filter">
            <div class="sort">
              <span
                :class="onlyShowPlay ? 'only-can-play cur' : 'only-can-play'"
                @click="onlyCanPlay"
                >可播放唱片</span
              >
            </div>
          </div>
        </div>

        <div class="right-content">
          <div class="result-count">
            <span
              >共<b>{{ rowCount }}</b
              >种</span
            >
            <div
              :class="showMobileFilter ? 'mb-filter-btn cur' : 'mb-filter-btn'"
              @click.stop="showMobileFilter = !showMobileFilter"
            >
              筛选
            </div>
            <div class="sort">
              <span :class="sort.field === 'TI' ? ['cur', sort.order === 'asc' ? 'reverse' : ''] : 'reverse'" @click="handleSortChange('TI')"
                >题名</span
              >
              <span :class="sort.field === 'TIME' ? ['cur', sort.order === 'asc' ? 'reverse' : ''] : 'reverse'" @click="handleSortChange('TIME')"
                >出版时间</span
              >
              <span :class="sort.field === 'CO' ? ['cur', sort.order === 'asc' ? 'reverse' : ''] : 'reverse'" @click="handleSortChange('CO')"
                >责任者</span
              >
              <span
                :class="onlyShowPlay ? 'only-can-play cur' : 'only-can-play'"
                @click="onlyCanPlay"
                >可播放唱片</span
              >
            </div>
          </div>
          <div class="filter-keys" v-if="filterKeys.length > 0">
            <div class="lb">已选项：</div>
            <div
              v-for="(f, index) in filterKeys"
              :key="index + f.text"
              class="f-k"
            >
              <b v-if="f.name">{{ f.name }}:</b>
              {{ f.text }} <i class="cls" @click="deleteFilter(f, index)"></i>
            </div>
          </div>
          <div class="result-list">
            <div
              v-for="(item, index) in recordList"
              :key="index"
              class="result-cell"
            >
              <div class="index">{{ index + 1 }}</div>
              <div class="pic">
                <router-link
                  :to="'/rec-info/' + encodeURIComponent(item['@id'])"
                >
                  <img
                    v-if="item.cover[0]"
                    :src="
                      'https://img.library.sh.cn/hisdata/cp/img/' +
                      item.cover[0]
                    "
                    alt=""
                  />
                  <img v-else :src="baseRecordPic" alt="" />
                </router-link>
              </div>
              <div class="info">
                <router-link
                    :to="'/rec-info/' + encodeURIComponent(item['@id'])"
                  >
                <div
                  class="name"
                  v-if="item.dcTitle"
                  :title="item.dcTitle['@value']"
                >
                  
                    {{
                      item.dcTitle["@value"]
                        .replace("~", "")
                        .replace("=", "")
                        .replace(":", "")
                        .replace(/[||]/g, "#")
                        .replace(/##/g, "")
                    }}
                </div>
                <div class="des" v-if="item.creator">
                    <!-- <span>何占豪</span>独奏
                    <span>何占豪</span>词
                    <span>何占豪</span>曲 -->
                    <span
                      :title="
                        Array.isArray(item.creator)
                          ? item.creator.join('\xa0\xa0\xa0')
                          : item.creator
                      "
                    >
                      {{
                        Array.isArray(item.creator)
                          ? item.creator.join("\xa0\xa0\xa0")
                          : item.creator
                      }}
                    </span>
                  </div>
                  <!-- <div class="des" v-if="item.provisionActivity && item.provisionActivity.date">
                    <span>{{item.provisionActivity.date}}年</span>出版
                  </div> -->
                  <div class="des" v-if="item.language">
                    语种：  <span>{{ item.language["@value"] }}</span>
                  </div>
                  <div class="des" v-if="item.genre">
                    <span>{{ item.genre }}</span>
                  </div>
               </router-link>
              </div> 
              <div class="act">
                <span v-if="!item.playable" class="noplay"></span>
                <span
                  v-if="item.playable"
                  :class="playIndex == index ? 'play curPlay' : 'play'"
                  @click="playSong(item, index)"
                ></span>

                <span
                  :class="item.isFavorite ? 'fav cur' : 'fav'"
                  @click="handleFav(index)"
                ></span>
                <ShareIcon
                  :shareConfig="{
                    url: '/rec-info/' + encodeURIComponent(item['@id']),
                    title: item.dcTitle['@value'],
                  }"
                ></ShareIcon>
              </div>
            </div>
          </div>
          <div class="page-box">
            <a-pagination
              :total="pagerCount"
              :current="currentPage"
              @change="onChange"
              show-quick-jumper
              show-less-items
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ShareIcon from "@/components/shareIcon";
import { eventBus } from "./../../util/eventBus";
import { baseRecordPic } from "@/util/basePic";
import Player from "@/components/player";
import { phonorecordSearch, phonorecordInfo, collFav, ncollFav } from "@/api";
export default {
  components: {
    ShareIcon,
    Player,
  },
  data() {
    return {
      playIndex: -1,
      curIndex: -1,
      suFbjectDict: [],
      noplay: false,
      sc: false,
      visible: false,
      isFavorite: false,
      loginHref: null,
      sliderCurrVal: [1910, 2015], //日期检索条件值
      searchType: 1, // 检索类型 1：简单检索，2：高级检索，3：专业检索
      searchParams: {}, // 检索参数
      hasAudio: false,
      showMobileFilter: false,
      onlyShowPlay: false,
      baseRecordPic,
      subjectCount: 0,
      subjectCurrent: -1,
      subjectDict: [],
      plCount: 0,
      plCurrent: -1,
      plDict: [],
      langCount: 0,
      langCurrent: -1,
      langDict: [],
      facesTitleKey: [
        { key: "subject", title: "主题分类" },
        { key: "pl", title: "出版地点" },
        { key: "lang", title: "语种" },
      ],
      rowCount: 0,
      pagerCount: 1,
      currentPage: 1,
      recordList: [],
      cdtn: [],
      showAll: [true, true, true, false, false, false],
      filterKeys: [],
      keyword: this.$route.query.keyword,
      sort: {
        field: "TI",
        order: "asc"
      }
    };
  },
  beforeRouteUpdate(a) {
    if (a.query.keyword) {
      this.filterKeys.splice(0, 1, {
        text: a.query.keyword,
        dict: "keyword",
      });
    } else {
      this.filterKeys = [];
    }
    this.currentPage = 1;
  },
  mounted() {
   if(this.GLOBAL.BASE_IP_INFO.ipIsInner){//如果是内网，则默认勾选可播放 chenss 20220909
    this.onlyShowPlay = true;
    this.hasAudio = this.onlyShowPlay;
   }
    this.loginHref = this.GLOBAL.BASE_LOGIN_URL + window.location.href;
    this.$nextTick(() => {
      document.body.addEventListener("click", () => {
        this.showMobileFilter = false;
      });
      if (this.$route.query.keyword) {
        this.filterKeys.push({
          text: this.$route.query.keyword,
          dict: "keyword",
        });
      }
      this.searchParams = this.commonParamsHandling();
    });
  },
  beforeDestroy() {
    document.body.removeEventListener("click", () => {
      this.showMobileFilter = false;
    });
  },
  watch: {
    $route: {
      handler: function (val, oldVal) {
        //如果搜索的参数有修改，则需要更改或删除当前列表检索条件
        this.initFilterKeys();
      },
    },
  },
  methods: {
    initBus() {
      eventBus.$on("setAdvance", (data) => {
        data.forEach((item) => {
          this.filterKeys.push({
            text: item.val,
            dict: item.name,
          });
        });
      });
    },
    initData() {
      // 初始化
      // this.recordList = [];
      this.rowCount = 0;
    },
    //日期检索 条件设置
    onSliderChange(value) {
      this.sliderCurrVal = value;
      this.dateCdtn = [];
      this.dateParams.logic = "and";
      this.dateParams.field = "IS";
      this.dateParams.value = this.sliderCurrVal[0];
      this.dateParams.type = "2"; //大于起始日期
      this.dateCdtn.push(this.dateParams);
      this.dateParams = {};
      this.dateParams.logic = "and";
      this.dateParams.field = "IS";
      this.dateParams.value = this.sliderCurrVal[1];
      this.dateParams.type = "3"; //小于结束日期
      this.dateCdtn.push(this.dateParams);
      this.query(true); //查询数据， 并且刷新分面数据
    },
    initFilterKeys() {
      //如果搜索的参数有修改，则需要更改或删除当前列表检索条件
      if (this.$route.query.keyword) {
        for (let i = 0; i < this.filterKeys.length; i++) {
          if (this.filterKeys[i].dict == "keyword") {
            this.filterKeys.splice(i, 1);
          }
        }
        this.filterKeys.push({
          text: this.$route.query.keyword,
          dict: "keyword",
        });
      } else if (!this.$route.query.keyword) {
        for (let i = 0; i < this.filterKeys.length; i++) {
          if (this.filterKeys[i].dict == "keyword") {
            this.filterKeys.splice(i, 1);
          }
        }
      }
    },
    onlyCanPlay() {
      // 仅显示可播放唱片
      this.onlyShowPlay = !this.onlyShowPlay;
      this.hasAudio = this.onlyShowPlay;
      this.query();
    },
    onParamsHandle() {
      // 检索参数设置
      // 初始化
      this.initData();
      this.searchParams = this.commonParamsHandling();
      if (this.hasAudio) {
        // this.searchParams.facet = { hasAudio: this.hasAudio + "" };
        this.searchParams.resouce = { PLAY: "1" };
      }
      // 排序
      const { field, order } = this.sort;
      this.searchParams.sorts = {
        [field]: order === "asc" ? 1 : 0
      };
      // 页码翻页
      this.searchParams.pager.pageth = this.currentPage;
      // 高级搜索，如果高级搜索有内容，则需要添加到已选项中，高级搜索清空之后，则需要清空已选项中的高级搜索内容
      if (this.cdtn.length != 0) {
        for (let j = 0; j < this.filterKeys.length; j++) {
          if (this.filterKeys[j].name) {
            this.filterKeys.splice(j, 1);
            j--;
          }
        }
        this.searchParams.cdtn = this.cdtn;
        this.searchParams.searchType = 2;
        for (let i = 0; i < this.cdtn.length; i++) {
          for (let j = 0; j < this.filterKeys.length; j++) {
            if (this.filterKeys[j].name == this.cdtn[i].name) {
              this.filterKeys.splice(j, 1);
            }
          }
          this.filterKeys.push({
            text: this.cdtn[i].value,
            name: this.cdtn[i].name,
            dict: this.cdtn[i].name,
          });
        }
      } else {
        for (let j = 0; j < this.filterKeys.length; j++) {
          if (this.filterKeys[j].name) {
            this.filterKeys.splice(j, 1);
            j--;
          }
        }
      }
      if (this.filterKeys.length < 1) return;
      let sim = false;
      this.filterKeys.forEach((item, index) => {
        const dict = item.dict;
        // 简单检索
        if (dict == "keyword") {
          this.searchParams.searchType = 1;
          this.searchParams.freetext = item.text;
        }
        // 分面参数
        if (dict.indexOf("Dict") != -1) {
          this.searchParams.facet[dict.replace("Dict", "").toUpperCase()] =
            item.text;
        }
      });
    },
    async handleFav(index) {
      //点击收藏如果没有登录,则提示用户登录后方可操作
      if (
        !localStorage.getItem("token") ||
        localStorage.getItem("token") == ""
      ) {
        this.$parent.showTk(2);
        return;
      }
      const res = this.recordList[index].isFavorite
        ? await ncollFav({ uri: this.recordList[index]["@id"] })
        : await collFav({ uri: this.recordList[index]["@id"] });
      //console.log(res);
      this.recordList.splice(index, 1, {
        ...this.recordList[index],
        isFavorite: !this.recordList[index].isFavorite,
      });
      this.isFavorite = !this.isFavorite;
      this.$parent.coll(this.recordList[index].isFavorite);
    },
    async query(facetsFlag = true) {
      // 参数设置
      this.onParamsHandle();
      const res = await phonorecordSearch(this.searchParams);
      const result = res.data;
      // 内容
      this.recordList = result.datas;
      // 分面
      if (facetsFlag) {
        // 题材
        this.subjectDict =
          result.facets && result.facets.subjectFacet
            ? result.facets.subjectFacet
            : [];
        // 体裁
        this.plDict =
          result.facets && result.facets.plFacet ? result.facets.plFacet : [];
        // 语种
        this.langDict =
          result.facets && result.facets.langFacet
            ? result.facets.langFacet
            : [];
      }
      // 统计数量
      this.facesTitleKey.forEach((item, index) => {
        this.countHnadle(item.key);
      });
      // 总数
      this.rowCount =
        result.pager && result.pager.rowCount ? result.pager.rowCount : 0;
      // 页码
      this.pagerCount =
        result.pager && result.pager.rowCount ? result.pager.rowCount : 1;
    },
    countHnadle(key) {
      // 统计数量
      this[key + "Count"] = 0;
      this[key + "Dict"].forEach((item, index) => {
        this[key + "Count"] += item.count;
      });
    },
    handleSortChange(field) {
      if (field === this.sort.field) {
        this.sort.order = this.sort.order === "asc" ? "desc" : "asc";
      } else {
        this.sort.field = field;
        this.sort.order = "asc";
      }
      this.query(false);
    },
    showAllHandle(a) {
      this.showAll.splice(a, 1, !this.showAll[a]);
      let count = 0;
      this.showAll.forEach((item) => {
        if (item) {
          count++;
        }
      });
      if (count > 3) {
        let flag = false;
        this.showAll.forEach((item, index) => {
          if (item && index !== a && !flag) {
            flag = true;
            this.showAll.splice(index, 1, false);
          }
        });
      }
    },
    deleteFilter(item, index) {
      //item中包含name字段，则代表是高级搜索，无，则是正常的左侧栏搜索
      // 删除包含name字段时，则需要修改高级搜索的查询条件
      if (item.name) {
        for (let i = 0; i < this.cdtn.length; i++) {
          if (this.cdtn[i].name == item.name) {
            this.cdtn.splice(i, 1);
          }
        }
      } else {
       let key = this.filterKeys[index].dict.substring(0,this.filterKeys[index].dict.search("Dict"));
       this[key + "Current" ] = -1;
      }

      this.filterKeys.splice(index, 1);
      this.currentPage = 1;
      this.query();
    },
   getFacetText(key) {
     const _i = this.filterKeys.findIndex((item) => {
        return item.dict === key ;
      });//是否找到了分面字典关键字 -1未找到如：subjectDict
      if(this.filterKeys[_i]){  return this.filterKeys[_i].text;}
      return '';
    },
   handleFilter(item, index, key) {
      
      this[key + "Current"] = item.facet ? item.facet : item;//被选中的分面值
      const _i = this.filterKeys.findIndex((item) => {
        return item.dict === key + "Dict";
      });//是否找到了分面字典关键字 -1未找到如：subjectDict
      let facValue = this[key + "Dict"][index] && this[key + "Dict"][index].facet ? this[key + "Dict"][index].facet :'';//真正选中的分面值
      if (_i !== -1) {
          //如果是专题，则可以多选
          if(this.filterKeys[_i]){
            let tempList =this.filterKeys[_i].text.split(',');
              if(tempList.indexOf(facValue)==-1){//如果已转中数组中不存在当前值，则继续存入
                  if(facValue !=null && facValue!=''){
                  tempList.push(facValue);//被选中的主题分类数据
                  this.filterKeys[_i].text=tempList.join(',');
                  }
                  }
               else if(tempList.length>1) {//如果剩下的不是最后一个时候，允许移除
                tempList.splice(tempList.indexOf(facValue),1);//如果存在，则删除该值，重新查询
              }
              facValue =tempList.join(',');
           }
          if (index === -1) {
            this.filterKeys.splice(_i, 1);
            // console.log('index === -1')
          } else {
            this.filterKeys.splice(_i, 1, {dict: key + "Dict", text: facValue});
          }
      } else if(facValue !=null && facValue!=''){//选中的分面值，如果不为空 做新增
           this.filterKeys.push({dict: key + "Dict", text: facValue});
      }
      this.currentPage = 1;
      this.totalPage = 10;
      this.query();
    },
    curPlay() {
      this.playIndex = this.curIndex;
    },
    async playSong(item, index) {
      this.curIndex = index;
      this.$refs.player.playSong(this.$parent, item);
    },
    onChange(current) {
      // 页码点击
      this.currentPage = current;
      this.query(false);
    },
  },
};
</script>
<style lang="less" scoped>
/deep/.ant-slider-handle {
  background: #ffffff;
  box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
  border: none;
  margin-top: -5px;
  width: 20px;
  height: 20px;
  &:focus {
    box-shadow: 0 1px 5px rgba(0, 0, 0, 0.2);
  }
}
/deep/.ant-slider-track {
  background: #eb5757 !important;
}
/deep/.ant-slider-rail,
/deep/.ant-slider-track {
  height: 10px;
}
/deep/.ant-slider {
  margin-top: 4px;
}
</style>